import { useSuspenseQuery } from '~/services'
import { useSaleEvent } from '../hooks/useSaleEvent'

export const SaleEventBannerWrapper = ({ workspaceId }: { workspaceId: string }) => {
  const {
    data: { billingReadonly },
  } = useSuspenseQuery('workspaces_/$workspaceId_/billing/info', { workspaceId })

  if (billingReadonly) return null

  return <SaleEventBanner workspaceId={workspaceId} />
}

const SaleEventBanner = ({ workspaceId }: { workspaceId: string }) => {
  const saleEvent = useSaleEvent(workspaceId)

  return saleEvent ? <saleEvent.Banner workspaceId={workspaceId} /> : null
}
